// extracted by mini-css-extract-plugin
export default {"-large":"LeBA739sxidwzxMbN4L5","placeholderIcon":"QNLx6NiMIwtMBOaFLu1I","medium":"DnV_QO5roQpAfUqTKsdJ","large":"ttj7AEqlxXqOqru6A2d8"};